
export default {
    name: 'BaseToggle',

    props: {
        title: {
            type: String,
            default: '',
        },
        initialState: {
            type: Boolean,
            default: true,
        },
        classless: {
            type: Boolean,
            default: false,
        },
        iconColor: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            open: this.initialState,
        }
    },

    watch: {
        initialState() {
            this.open = this.initialState
        },
    },

    methods: {
        toggle() {
            this.open = !this.open
            this.$emit('toggle')
        },
    },
}
